// SubPlayTemplateView 组件通用 API
import jsBridge from "../../common/jsBridge";

/**
 * 创建一个 "type 4 类型" 组件
 * @param campaign
 * @param unitId
 * @param unitSetting
 * @param sdkSetting
 * @returns {*|Promise<any>}
 */
export function createSubPlayTemplateView({campaign, unitId, unitSetting, sdkSetting}) {
    let mute = sdkSetting && sdkSetting.playVideoMute
    let params = {
        unitId,
        data: {
            mute, // 默认为0 非静音，1 静音
            campaign,
            unitId,
            unitSetting,
        },
    }
    let callNativeResponse = jsBridge.callNative({fnName: 'VideoBridge/createSubPlayTemplateView', params});
    console.log('createSubPlayTemplateView: ', {params, callNativeResponse})
    return callNativeResponse
}

export function preloadSubPlayTemplateView({unitId, id}) {
    let params = {
        unitId,
        id,
        data: {}
    }
    console.log('preloadSubPlayTemplateView: ', params)
    return jsBridge.callNative({fnName: 'VideoBridge/preloadSubPlayTemplateView', params})
}

export function setSubPlayTemplateInfo({unitId, id, data}) {
    let params = {
        unitId,
        id,
        data,
    }
    console.log('setSubPlayTemplateInfo: ', params)
    return jsBridge.callNative({fnName: 'VideoBridge/setSubPlayTemplateInfo', params})
}